import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ABaseTreeNode } from '../../../../components/common/basetreecontrol/base.tree.control';
import { ClassTransformerHelper } from '../../../../helpers/class.transformer.helper';
import { WorkflowType } from '../../../../models/enums/workflowtype.enum';
import { DataModelService, DataSourceQuery } from '../../../../services/datamodel.service';
import { WorkflowExitInfo, WorkflowModuleSettingsHelper, WorkflowRegistry } from '../../../../services/workflow.service';
import { DataCheck, FormulaWorkflowDialogContent } from '../../../../workflow/workflow.dialog';

@Component({
    selector: 'wf-load-resource-settings-item',
    templateUrl: 'load.resource.settings.html'
})
export class LoadResourceSettings extends FormulaWorkflowDialogContent {
    Data = new LoadResourceSettingsData();
    DataModels = [];
    DataSources = [];
    VariableNodes = [];

    public static GetRegistry(): WorkflowRegistry {
        const reg = new WorkflowRegistry();
        reg.ID = 'LoadResourceWFModule';
        reg.Caption = '@@Resource laden';
        reg.GroupID = 'fileoperations';
        reg.Index = 5;
        reg.SettingsControl = LoadResourceSettings;
        reg.SettingsTypeHelper = new LoadResourceSettingsDataHelper();
        reg.WorkflowType = WorkflowType.Service;
        return reg;
    }

    constructor(private service: DataModelService, private translate: TranslateService) {
        super();
    }

    initialize(data: any) {
        super.initialize(data);
        let index = 0;
        const varNodes = [];
        this.Variables.forEach(x => {
            const btn = new ABaseTreeNode(index++);
            btn.Caption = x.Name;
            varNodes.push(btn);
        });
        this.VariableNodes = varNodes;
        if (data) {
            this.Data = ClassTransformerHelper.CopyObject(data, LoadResourceSettingsData);
        }
        this.service.GetModels().subscribe(x => {
            if (x) {
                this.DataModels = x;
            }
            if (this.Data.DataModelID) {
                if (this.DataModels.some(y => y.SID === this.Data.DataModelID)) {
                    this.loadDataSources();
                } else {
                    this.Data.DataModelID = null;
                    this.Data.DataSource = null;
                }
            }
        });
    }

    checkData(): DataCheck {
        const retVal = new DataCheck();
        const errors = [];
        if (!this.Data.DataSource) {
            errors.push(this.translate.instant('@@Bitte setzen Sie eine Datenquelle'));
        }
        if (!this.Data.FileName) {
            errors.push(this.translate.instant('@@Bitte vergeben Sie einen Dateinamen'));
        }
        if (!this.Data.UseForState && !this.Data.StatusKey) {
            errors.push(this.translate.instant('@@Bitte vergeben Sie einen Status Key fuer das Ergebnis oder setzen Sie das Ergebnis als aktuellen Parameter'));
        }
        if (errors.length > 0) {
            retVal.IsCorrect = false;
            retVal.Error = errors.join('\n');
        }
        return retVal;
    }

    getResult() {
        return this.Data;
    }

    dataModelChanged() {
        this.Data.DataSource = null;
        this.loadDataSources();
    }

    loadDataSources() {
        this.DataSources = [];
        if (this.Data.DataModelID) {
            const query = new DataSourceQuery(this.Data.DataModelID);
            query.ResourceBase = 1; // Filebase
            this.service.GetDataSourcesByQuery(query).subscribe(x => {
                if (x) {
                    this.DataSources = x;
                }
            });
        }
    }

    onFileNameSelect(event) {
        if (event) {
            this.Data.FileName = event.Caption;
        }
    }
}

export class LoadResourceSettingsData {
    DataModelID: string;
    DataSource: string;
    FileName: string;
    GetFileNameFromStatus = false;
    ResourceType: ResourceType = ResourceType.Text;
    StatusKey: string;
    UseForState = false;
}

export enum ResourceType {
    Text,
    Bytes
}

export class LoadResourceSettingsDataHelper extends WorkflowModuleSettingsHelper {
    getExitPoints(settings: any): WorkflowExitInfo[] {
        return [new WorkflowExitInfo()];
    }
    getEmptySettingsInstance() {
        return new LoadResourceSettingsData();
    }
}
